import { Injectable } from '@angular/core';
import { FormTemplatesService } from './form-templates.interface';
import { Page, FormTemplateApi, FormTemplateUsage } from '@models';
import { Observable } from 'rxjs';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class FormTemplatesApiService
  extends HttpService<FormTemplateApi>
  implements FormTemplatesService
{
  protected override readonly collectionPath = '/consent-forms/templates';

  getFormTemplates(params: {
    page: number;
    pageSize: number;
    status?: string;
    patientName?: string;
    orderBy?: string;
    desc?: boolean;
    usage?: FormTemplateUsage;
  }): Observable<Page<FormTemplateApi>> {
    return this.getCollectionByQuery(params);
  }

  getFormTemplate(id: string): Observable<FormTemplateApi> {
    return this.getItemById<FormTemplateApi>(id);
  }

  getFormTemplateNameById(id: string): Observable<string> {
    return this.http.get<string>(`${this.apiUrl}/${id}/name`);
  }
}
